<div class="min-h-screen flex flex-col background-mb text-gray-900 dark:text-gray-100">
    <app-mb-header></app-mb-header>
    <div class="flex justify-center flex-grow">
        <div class="flex flex-col items-start my-10 ml-10">
            <button
                    class="p-2 mb-4 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    (click)="this.toggleMenu()"
                    aria-label="Toggle Menu"
            >
                <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="2"
                     viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>
            </button>

            <div [class.hidden]="this.isMenuCollapsed" class="transition-all duration-300 ease-in-out">
                <app-menu></app-menu>
            </div>
        </div>

        <div class="flex flex-1 flex-col min-w-0">
            <p-toast position="top-right"></p-toast>
            <p-confirmDialog #cd>
                <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
                    <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded">
                        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
                        <p class="mb-0 text-gray-500 dark:text-gray-300">{{ message.message }}</p>
                        <div class="flex items-center gap-2 mt-6">
                            <p-button label="Confirm" (onClick)="onAccept()" severity="primary"></p-button>
                            <p-button label="Cancel" (onClick)="onReject()" severity="secondary"></p-button>
                        </div>
                    </div>
                </ng-template>
            </p-confirmDialog>

            <main class="m-10 border border-gray-300 dark:border-gray-700 rounded-sm p-6 main-background-mb">
                <router-outlet></router-outlet>
            </main>
        </div>

        <p-toast position="top-right"></p-toast>
    </div>
    <footer class="border-t border-gray-300 dark:border-gray-700 bg-black text-gray-700 dark:text-gray-300 py-4">
        <div class="container mx-auto text-center">
            <div class="flex justify-center gap-6 mb-4">
                <a routerLink="/legal/imprint"
                   class="px-3 py-2">Imprint</a>
                <a routerLink="/legal/privacy"
                   class="px-3 py-2 ">Privacy</a>
            </div>
            <p class="text-sm">&copy; 2025 Mercedes-Benz. All rights reserved.</p>
        </div>
    </footer>
</div>
